import { InputDataList } from "../../../../components/modal/FormModal";
import { PostVehicleDto } from "../../../../../network/control/Vehicle";
import { TimePickerInput } from "../../../../components/input/TimePicker";
import { Schema } from "rsuite";
import { isNotBlank } from "../../../../../util/validation";

export const NewVehicleInputSchema = Schema.Model({
  entry: Schema.Types.NumberType().isRequired(
    "Es necesario colocar la hora de ingreso."
  ),
  driver: Schema.Types.StringType()
    .isRequired("Es necesario completar este campo.")
    .addRule(isNotBlank(3), "Debe contener al menos 3 caracteres."),
  plate: Schema.Types.StringType().isRequired(
    "Es necesario completar este campo."
  ),
  dni: Schema.Types.StringType().isRequired(
    "Es necesario completar este campo."
  ),
});

export const EditVehicleInputSchema = Schema.Model({
  departure: Schema.Types.NumberType(),
  observation: Schema.Types.StringType(),
});

export const NewVehicleInputList: InputDataList<PostVehicleDto> = [
  {
    name: "entry",
    label: "Hora de ingreso",
    type: "custom",
    provide: TimePickerInput("entry"),

    defaultValue: undefined,
  },
  {
    name: "departure",
    label: "Hora de salida",
    type: "custom",
    provide: TimePickerInput("departure"),
    defaultValue: undefined,
  },
  {
    name: "plate",
    label: "Placa",
    type: "text",
    placeholder: "Placa del vehiculo",
    defaultValue: undefined,
  },
  {
    name: "dni",
    label: "DNI",
    type: "text",
    placeholder: "DNI",
    defaultValue: undefined,
  },
  {
    name: "driver",
    label: "Nombre y apellidos",
    type: "text",
    placeholder: "Nombre y apellidos",
    defaultValue: undefined,
  },
  {
    name: "license",
    label: "Licencia",
    type: "text",
    placeholder: "Licencia",
    defaultValue: undefined,
  },
  {
    name: "guide",
    label: "Guia",
    type: "text",
    placeholder: "Guia",
    defaultValue: undefined,
  },
  {
    name: "ramp",
    label: "Rampa",
    type: "text",
    placeholder: "Rampa",
    defaultValue: undefined,
  },
  {
    name: "destination",
    label: "Destino",
    type: "text",
    placeholder: "Destino",
    defaultValue: undefined,
  },
  {
    name: "observation",
    label: "Observacion",
    type: "text",
    placeholder: "Observacion",
    defaultValue: undefined,
  },
  {
    name: "derivation",
    label: "Derivacion",
    type: "text",
    placeholder: "Derivacion",
    defaultValue: undefined,
  },
];

export const EditVehicleInputList: InputDataList<PostVehicleDto> = [
  {
    name: "departure",
    label: "Hora de salida",
    type: "custom",
    provide: TimePickerInput("departure"),
    defaultValue: undefined,
  },
  {
    name: "observation",
    label: "Observacion",
    type: "text",
    placeholder: "Observacion",
    defaultValue: undefined,
  },
];
